import { render, staticRenderFns } from "./FicheSuivi.vue?vue&type=template&id=dedb0e20&"
import script from "./FicheSuivi.vue?vue&type=script&lang=js&"
export * from "./FicheSuivi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports